// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-timeline[data-v-879a380c]{list-style:none;padding:0;margin:0;position:relative;margin-left:1rem}", ""]);
// Exports
module.exports = exports;
